export default __webpack_public_path__ + "static/media/KOD0054-min.c15ac03e.webp";